export default "__VITE_ASSET__7ae60410__"